import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import BiddersList from "./BiddersList";

let routes = [
  {
    path: 'bidders',
    name: 'bidders',
    component: BiddersList,
    meta: {
      requiresAuth: true
    }
  },
];


export default {
  menuItem: new MenuItem('/bidders', i18n.t('Bidders'), 30, 'user-friends', [], 'view_bidder'),
  routes: routes
}
